const MARKDOWN_PROVIDER_KEY = Symbol('vue-element-plus-x-markdown-provider');
const GLOBAL_SHIKI_KEY = Symbol('vue-element-plus-x-markdown-shiki-provider');

const MERMAID_CACHE_KEY_LENGTH = 10000;

export { GLOBAL_SHIKI_KEY, MARKDOWN_PROVIDER_KEY, MERMAID_CACHE_KEY_LENGTH };
